/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** 2×2 grid outline (16×16). Color via `currentColor`. */
const GridIcon = ({
  size = 16,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <rect x="2.25" y="2.25" width="4.75" height="4.75" rx="0.75" stroke="currentColor" strokeWidth="1.25" />
    <rect x="9" y="2.25" width="4.75" height="4.75" rx="0.75" stroke="currentColor" strokeWidth="1.25" />
    <rect x="2.25" y="9" width="4.75" height="4.75" rx="0.75" stroke="currentColor" strokeWidth="1.25" />
    <rect x="9" y="9" width="4.75" height="4.75" rx="0.75" stroke="currentColor" strokeWidth="1.25" />
  </svg>
);

GridIcon.propTypes = iconPropTypes;

export default GridIcon;
